import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react'
import { fetchAllAssets, fetchAssetDetailsByAssetId, fetchAssetSummary } from '../../../core/data/redux/asset/asset/assetActions';
import { AppDispatch } from '../../../core/data/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { DatePicker, Drawer, message } from 'antd';
import { allocateAsset, fetchAllAllocations } from '../../../core/data/redux/asset/assetAllocation/assetAllocationActions';
import { fetchAllAssetRequests } from '../../../core/data/redux/asset/assetRequest/assetRequestAction';
import { filterByStatus } from '../../../core/utils/filterActiveData';
import { fetchAllMaintenances } from '../../../core/data/redux/asset/assetMaintenanceAction/assetMaintenanceAction';

const AssetAllocationModel: React.FC<any> = ({ assetAllocationModal, setAssetAllocationModal, isModalVisible, modalType, selectedRowData, setTableKey }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: any) => state.auth);
    const { employees } = useSelector((state: any) => state.employee);
    const employeeData = employees ? employees : []
    const { assetDetails, loading } = useSelector((state: any) => state.asset.newAsset);
    const isLoading = modalType === "edit" ? loading.update : loading.create;
    const { assetRequests = [] } = useSelector((state: any) => state.asset.assetRequest);
    const [filteredRequests, setFilteredRequests] = useState<any[]>([]);
    const { assetAllocations } = useSelector((state: any) => state.asset.assetAllocation);
    const activeEmployee = filterByStatus(employeeData, "active", "employee_status");
    const [errors, setErrors] = useState<any>({});
    const { maintenances } = useSelector((state: any) => state.asset.assetMaintenance);
    const [assetAllocationData, setAssetAllocationData] = useState<any>({
        asset_id: selectedRowData?.assetId || '',
        serial_number: '',
        employee_id: '',
        allocated_by: '',
        allocated_at: dayjs(),
        expected_return_date: dayjs(),
        actual_return_date: dayjs(),
        allocation_status: 'allocated',
        remarks: '',
    });
    const resetForm = () => {
        setAssetAllocationData({
            asset_id: '',
            serial_number: '',
            employee_id: '',
            allocated_by: '',
            allocated_at: dayjs(),
            expected_return_date: dayjs(),
            actual_return_date: dayjs(),
            allocation_status: 'allocated',
            remarks: '',
        });
        setErrors({})
    };

    useEffect(() => {
        dispatch(fetchAllAssetRequests());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchAllAllocations());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchAllMaintenances());
    }, [dispatch]);

    useEffect(() => {
        if (assetAllocationData.employee_id) {
            const assignedRequestNumbers = assetAllocations.map(
                (allocation: any) => allocation.RequestNumber
            );

            const approvedRequests = assetRequests.filter(
                (req: any) =>
                    req.EmployeeId == assetAllocationData.employee_id &&
                    req.AssetRequestStatus == "Approved" &&
                    !assignedRequestNumbers.includes(req.RequestNumber)
            );
            setFilteredRequests(approvedRequests);
        } else {
            setFilteredRequests([]);
        }
    }, [assetAllocationData.employee_id, assetRequests, assetAllocations]);
  
    const FieldError: React.FC<{ msg?: string }> = ({ msg }) =>
  msg ? <div className="text-danger small mt-1">{msg}</div> : null;

    // const employeesWithApprovedRequests = useMemo(() => {
    //     const approvedEmployeeIds = new Set(
    //         assetRequests
    //             .filter((req: any) => req.AssetRequestStatus === "Approved")
    //             .map((req: any) => req.EmployeeId)
    //     );

    //     return activeEmployee.filter((emp: any) =>
    //         approvedEmployeeIds.has(emp.EmployeeID)
    //     );
    // }, [assetRequests, activeEmployee]);

    useEffect(() => {
        if (selectedRowData?.assetId) {
            dispatch(fetchAssetDetailsByAssetId({ assetId: selectedRowData?.assetId }));
        }
    }, [dispatch, selectedRowData?.assetId, selectedRowData])

    const handleInputChange = (e: any, field: string) => {
        const { value } = e.target;
        setAssetAllocationData((prevState: any) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleSubmit = async () => {
        let newErrors: any = {};

    // Required fields check
    const requiredFields = ['serial_number', 'employee_id', 'RequestNumber','allocated_by', 'allocated_at', 'expected_return_date'];
    requiredFields.forEach((field) => {
        if (!assetAllocationData[field]) {
            newErrors[field] = `Please fill in the ${field.replace(/_/g, " ")} field.`;
        }
    });

    // Date checks
    if (
        assetAllocationData.expected_return_date &&
        assetAllocationData.allocated_at &&
        assetAllocationData.expected_return_date.isBefore(assetAllocationData.allocated_at, "day")
    ) {
        newErrors.expected_return_date = "Expected return date cannot be before allocated date.";
    }

    if (
        assetAllocationData.actual_return_date &&
        assetAllocationData.allocated_at &&
        assetAllocationData.actual_return_date.isBefore(assetAllocationData.allocated_at, "day")
    ) {
        newErrors.actual_return_date = "Actual return date cannot be before allocated date.";
    }

    setErrors(newErrors);

    // Stop if errors exist
    if (Object.keys(newErrors).length > 0) {
        return;
    }
        const updatedFormData = {
            ...assetAllocationData,
            CreatedBy: user.UserId,
            asset_id: selectedRowData?.assetId
        };
        try {
            let result;
            result = await dispatch(allocateAsset(updatedFormData)).unwrap();
            if (result) {
                message.success(result.message);
                resetForm();
                await dispatch(fetchAllAssets());
                await dispatch(fetchAssetSummary())
                setTableKey((prevKey: any) => prevKey + 1);
            }
            setAssetAllocationModal(false)
        } catch (error) {
            message.error('An error occurred');
        }
    };

    const getModalContainer = () => {
        const modalElement = document.getElementById('modal-datepicker');
        return modalElement ? modalElement : document.body;
    };

    return (
        <Drawer
            title="Allocate Asset"
            placement="right"
            width={700}
            onClose={() => {
                setAssetAllocationModal(false);
                resetForm();
            }}
            visible={assetAllocationModal}
            style={{ marginTop: 50, paddingBottom: 50 }}
        >
            <div className="add-info-fieldset ">
                <div className="contact-grids-tab p-3 pb-0">
                    <ul className="nav nav-underline" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link active"
                                id="basic-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#basic-info"
                                type="button"
                                role="tab"
                                aria-selected="true"
                            >
                                Basic Information
                            </button>
                        </li>
                    </ul>
                </div>
                <div className="tab-content" id="myTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="basic-info"
                        role="tabpanel"
                        aria-labelledby="basic-tab"
                        tabIndex={0}
                    >
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Asset <span className="text-danger"> *</span></label>
                                            <select
                                                className="form-control"
                                                value={assetAllocationData.asset_id}
                                                onChange={(e) => handleInputChange(e, 'asset_id')}
                                            >
                                                {selectedRowData?.assetId ? (
                                                    <option key={selectedRowData.assetId} value={selectedRowData.assetId}>
                                                        {selectedRowData.AssetName}
                                                    </option>
                                                ) : (
                                                    <option disabled>No Asset Selected</option>
                                                )}
                                            </select>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Asset Serial Number <span className="text-danger"> *</span></label>
                                            <select
                                                className="form-control"
                                                value={assetAllocationData.serial_number}
                                                onChange={(e) => handleInputChange(e, 'serial_number')}
                                            >
                                                <option value="">Select Asset Serial Number</option>
                                                {assetDetails
                                                    ?.filter((asset: any) => {
                                                        const isBlocked = maintenances.some((m: any) =>
                                                            m.asset_details_id === asset.asset_details_id &&
                                                            m.status !== "completed" &&
                                                            m.status !== "paid"
                                                        );
                                                        return !isBlocked;
                                                    })
                                                    .map((asset: any) => (
                                                        <option key={asset.asset_details_id} value={asset.SerialNumber}>
                                                            {asset.SerialNumber}
                                                        </option>
                                                    ))}
                                            </select>
                                            <FieldError msg={errors.serial_number} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Employee <span className="text-danger"> *</span></label>
                                            <select
                                                className="form-control"
                                                value={assetAllocationData.employee_id}
                                                onChange={(e) => handleInputChange(e, 'employee_id')}
                                            >
                                                <option value="">Select Employee</option>
                                                {activeEmployee.map((employee: any) => (
                                                    <option key={employee.EmployeeID} value={employee.EmployeeID}>
                                                        {employee.Name}
                                                    </option>
                                                ))}
                                            </select>
                                            <FieldError msg={errors.employee_id} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Request Number
                                            </label>
                                            <select
                                                className="form-control"
                                                value={assetAllocationData.RequestNumber}
                                                onChange={(e) => handleInputChange(e, "RequestNumber")}
                                            >
                                                <option value="">Select Request Number</option>
                                                {modalType === "edit" && assetAllocationData.RequestNumber &&
                                                    !filteredRequests.find((r) => r.RequestNumber === assetAllocationData.RequestNumber) && (
                                                        <option value={assetAllocationData.RequestNumber}>
                                                            {assetAllocationData.RequestNumber}
                                                        </option>
                                                    )}
                                                {filteredRequests.map((request: any) => (
                                                    <option key={request.RequestNumber} value={request.RequestNumber}>
                                                        {request.RequestNumber || `Request #${request.Id}`}
                                                    </option>
                                                ))}
                                            </select>
                                            <FieldError msg={errors.RequestNumber} />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Allocated By <span className="text-danger"> *</span></label>
                                                    <select
                                                        className="form-control"
                                                        value={assetAllocationData.allocated_by}
                                                        onChange={(e) => handleInputChange(e, 'allocated_by')}
                                                    >
                                                        <option value="">Select Employee</option>
                                                        {employeeData.map((employee: any) => (
                                                            <option key={employee.EmployeeID} value={employee.EmployeeID}>
                                                                {employee.Name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <FieldError msg={errors.allocated_by} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Allocated At <span className="text-danger"> *</span></label>
                                                    <div className="input-icon-end position-relative">
                                                        <DatePicker
                                                            className="form-control datetimepicker"
                                                            format="DD-MM-YYYY"
                                                            getPopupContainer={getModalContainer}
                                                            value={assetAllocationData.allocated_at}
                                                            onChange={(date) => setAssetAllocationData({ ...assetAllocationData, allocated_at: date })}
                                                            placeholder="DD-MM-YYYY"
                                                        />
                                                        <FieldError msg={errors.allocated_at} />
                                                        <span className="input-icon-addon">
                                                            <i className="ti ti-calendar text-gray-7" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Expected Return Date <span className="text-danger"> *</span></label>
                                                    <div className="input-icon-end position-relative">
                                                        <DatePicker
                                                            className="form-control datetimepicker"
                                                            format="DD-MM-YYYY"
                                                            getPopupContainer={getModalContainer}
                                                            value={assetAllocationData.expected_return_date}
                                                            onChange={(date) => setAssetAllocationData({ ...assetAllocationData, expected_return_date: date })}
                                                            placeholder="DD-MM-YYYY"
                                                        />
                                                        <FieldError msg={errors.expected_return_date} />
                                                        <span className="input-icon-addon">
                                                            <i className="ti ti-calendar text-gray-7" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Actual Return Date <span className="text-danger"> *</span></label>
                                                    <div className="input-icon-end position-relative">
                                                        <DatePicker
                                                            className="form-control datetimepicker"
                                                            format="DD-MM-YYYY"
                                                            getPopupContainer={getModalContainer}
                                                            value={assetAllocationData.actual_return_date}
                                                            onChange={(date) => setAssetAllocationData({ ...assetAllocationData, actual_return_date: date })}
                                                            placeholder="DD-MM-YYYY"
                                                        />
                                                        <FieldError msg={errors.actual_return_date} />
                                                        <span className="input-icon-addon">
                                                            <i className="ti ti-calendar text-gray-7" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="form-label">Remarks</label>
                                                    <textarea
                                                        className="form-control"
                                                        value={assetAllocationData.remarks}
                                                        onChange={(e) => handleInputChange(e, 'remarks')}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="d-flex align-items-center justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-outline-light border me-2"
                                        onClick={() => {
                                            setAssetAllocationModal(false);
                                            resetForm();
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button className="btn btn-primary" type="button" onClick={handleSubmit} disabled={isLoading}>
                                        {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
                                        {modalType === 'edit' ? 'Update Allocation' : 'Allocate Asset'}
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </Drawer >
    )
}

export default AssetAllocationModel